export default __webpack_public_path__ + "static/media/cewe_fixation_vis.d87d000e.jpg";